import EyeIcon from '@/assets/svg/ui-elements/eye-outline.svg';
import PencilIcon from '@/assets/svg/ui-elements/pencil.svg';
import RefreshIcon from '@/assets/svg/ui-elements/refresh.svg';
import { Badge, Tooltip } from '@/design-system';

import { ENTITY_STATUS_BADGES, UPDATED_BADGE_LABEL } from '../common';
import { StatusBadgeRow, StatusBadgeTrigger } from '../styled';
import { useCreateEntity } from '../use-create-entity';
import { useEntityReviewMode } from '../use-entity-review-mode';

const ICON_SIZE = 16;

export const UpdatedBadge = () => (
  <Badge
    label={UPDATED_BADGE_LABEL}
    color="yellow"
    variant="subtle"
    roundness="round"
    startIcon={<RefreshIcon width={ICON_SIZE} height={ICON_SIZE} />}
  />
);

export const WizardStatusBadges = () => {
  const { entityApprovalStatus } = useCreateEntity();
  const { isReviewMode } = useEntityReviewMode();

  if (!entityApprovalStatus) return null;

  const status = ENTITY_STATUS_BADGES[entityApprovalStatus];

  return (
    <StatusBadgeRow>
      {isReviewMode ? (
        <Badge
          label="Review mode"
          color="yellow"
          variant="subtle"
          roundness="round"
          startIcon={<EyeIcon width={ICON_SIZE} height={ICON_SIZE} />}
        />
      ) : (
        <Badge
          label="Edit mode"
          roundness="round"
          startIcon={<PencilIcon width={ICON_SIZE} height={ICON_SIZE} />}
        />
      )}

      <Tooltip side="right" title={status.info}>
        <StatusBadgeTrigger>
          <Badge label={status.label} color={status.color} variant="subtle" roundness="round" />
        </StatusBadgeTrigger>
      </Tooltip>
    </StatusBadgeRow>
  );
};
